// import {Link} from 'react-router-dom';
import React from 'react';
import { Shield, Mail, Phone, AlertCircle } from 'lucide-react';
const PrivacyPolicy: React.FC = () => {
    return(
      <>
      <div>
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Introduction Banner */}
          <div className="bg-gradient-to-r bg-primary to-[#0C2B5A] p-6 text-white">
            <div className="flex items-center space-x-4">
                <Shield className="w-8 h-8" />  
              <div>
                <h2 className="text-xl font-bold">Data Protection & Privacy</h2>
                {/* <p className="text-blue-100">Last updated: {new Date().toLocaleDateString()}</p> */}
              </div>
            </div>
          </div>

          {/* Policy Content */}
          <div className="p-8 space-y-8">
            {/* Introduction */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">1. Introduction</h3>
              <p className="text-gray-600">
                Welcome to the privacy policy of NEXEDZ. At NEXEDZ, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services and visit our website.
              </p>
            </section>

            {/* Information We Collect */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Information We Collect</h3>
              <p className="text-gray-600 mb-4">The types of personal information we may collect, include but are not limited to:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                <li>Contact Information (such as your name, email address, phone number)</li>
                <li>Billing and Payment Information</li>
                <li>Any other information you provide to us or that we may collect as permitted by law</li>
              </ul>
            </section>

            {/* How We Use Your Information */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">3. How We Use Your Information</h3>
              <p className="text-gray-600 mb-4">We may use the collected information for various purposes, including:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                <li>Providing our services to you</li>
                <li>Processing payments</li>
                <li>Communicating with you about our services and updates</li>
                <li>Improving our services</li>
                <li>Personalizing your experience</li>
                <li>Complying with legal requirements</li>
              </ul>
            </section>

            {/* Cookies */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Cookies and Tracking Technologies</h3>
              <p className="text-gray-600">
                We use cookies and similar tracking technologies to enhance your experience on our website and services. You can control how cookies are used through your browser settings.
              </p>
            </section>

            {/* Third-Party Disclosures */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">5. Third-Party Disclosures</h3>
              <p className="text-gray-600">
                We may share your information with third parties as necessary for the operation of our services and as required by law. These third parties may include payment processors, service providers.
              </p>
            </section>

            {/* Data Security */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">6. Data Security</h3>
              <p className="text-gray-600">
                We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, and destruction.
              </p>
            </section>

            {/* Your Rights */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">7. Your Rights</h3>
              <p className="text-gray-600">
                You have certain rights regarding your personal information, including the right to access, correct, or delete your data. To exercise these rights or inquire about your data, please contact us at support@nexedz.org.
              </p>
            </section>

            {/* Changes to Privacy Policy */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">8. Changes to Privacy Policy</h3>
              <p className="text-gray-600">
                We may update this Privacy Policy from time to time to reflect changes in our practices and services. We will post the revised policy on our website, and the changes will take effect when posted.
              </p>
            </section>

            {/* Contact Information */}
             <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">9. Contact Information</h3>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-600 mb-4">If you have any questions or concerns regarding our privacy practices or this Privacy Policy, please contact us at:</p>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3 text-gray-700">
                    <Mail className="w-5 h-5 text-[#0F3874]" />
                    <span>support@nexedz.org</span>
                  </div>
                  <div className="flex items-center space-x-3 text-gray-700">
                    <Phone className="w-5 h-5 text-[#0F3874]" />
                    <span>+91 7986040967</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Consent */}
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">10. Consent</h3>
              <div className="flex items-start space-x-3 bg-blue-50 p-4 rounded-lg">
                <AlertCircle className="w-6 h-6 text-[#0F3874] flex-shrink-0" />
                <p className="text-gray-600">
                  By using our services and website, you consent to our collection and use of your information as described in this Privacy Policy.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
      </div>
      </>
    );
}

export default PrivacyPolicy;